import React from 'react';
import noImage from '../../../assets/images/no-image.png';
import CustomTooltip from '../../../Components/Tooltip/CustomTooltip';

function BomImage({ dataValue, isPageDisable, handleImageUpload, handleImageDelete, t }) {
  const setImage = (image) => {
    let imagePath = '';
    if (image?.includes('data:image/')) {
      imagePath = image;
    } else if (image) {
      imagePath = image;
    } else {
      imagePath = noImage;
    }
    return imagePath;
  };
  return (
    <div className="image-container mr-0">
      <div className="image-border">
        <img width="50" src={setImage(dataValue?.previewImage || dataValue?.image)} height="50" alt="croppedImage" />
      </div>
      {!isPageDisable && (
        <div className="d-flex ml-1 flex-column">
          <CustomTooltip placement="top" tooltipText={t('SPEC_TEMP_LIBRARY.UPLOAD_IMAGE')}>
            <button aria-label="upload" className="btn p-0" onClick={() => handleImageUpload()} type="button">
              <span className="icon-Upload-1 text-grey-color f-18" aria-hidden="true" />
            </button>
          </CustomTooltip>
          {dataValue?.image && (
            <CustomTooltip placement="top" tooltipText={t('SPEC_TEMP_LIBRARY.REMOVE_IMAGE')}>
              <button aria-label="delete" className="btn p-0" onClick={() => handleImageDelete()} type="button">
                <span className="icon-Delete text-grey-color f-18" aria-hidden="true" />
              </button>
            </CustomTooltip>
          )}
        </div>
      )}
    </div>
  );
}

export default BomImage;
